/**
 * The shape rules for a campaign's scope key, on the client side.
 *
 * ps-back/util/email/campaignDraft.js is the authority and rejects the same
 * strings; this copy exists so a typo is named under the input as it is typed
 * instead of after a failed round trip. Keep the pattern identical to that file.
 *
 * Only the KEY is duplicated, not the title and kind rules. Those the server owns
 * alone — three rules kept in step across two languages is three chances to drift,
 * and the key is the only one whose failure is invisible (a badly-shaped key writes
 * a record that reads perfectly in the list and can never route).
 */
const KEY_PATTERN = /^[a-zA-Z0-9_]+$/;

function keyProblem(key) {
  // Trimmed first because the caller trims before sending. Without this a trailing
  // space from a paste reports as an invalid character the user cannot see.
  const value = (key || '').trim();
  if (!value) return 'A scope word is required.';
  if (!KEY_PATTERN.test(value)) {
    return 'Letters, numbers and underscores only — a space or a hyphen would make the campaign impossible to route.';
  }
  return null;
}

// Matches cloneTemplate() in ps-back/util/email/cloneCampaign.js.
function starterTemplateId(key, language) {
  return `${key}-${language}`;
}

module.exports = { keyProblem, starterTemplateId, KEY_PATTERN };
